import { render, staticRenderFns } from "./EstablishmentDirectoryListTable.vue?vue&type=template&id=2fefa466"
import script from "./EstablishmentDirectoryListTable.vue?vue&type=script&lang=js"
export * from "./EstablishmentDirectoryListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports